import React, { useState } from 'react'
import { Card, CardContent, CardFooter } from "@/shared/ui/card"
import { Label } from "@/shared/ui/label"
import { Input } from "@/shared/ui/input"
import { Button } from "@/shared/ui/button"
import { Slider } from "@/shared/ui/slider"
import { Link, useNavigate } from 'react-router-dom'
import { useCreateTransactionMutation } from '@/api/rtk/mutationsApi'
import { useDispatch } from 'react-redux'
import { setActiveTab } from '@/store/slices/ProfileSlice'
import { toast } from 'react-toastify'
import Loader from '@/shared/components/Loader'
import { useTranslation } from 'react-i18next'

const TokenTab = ({ setIsOpen }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [createTransaction] = useCreateTransactionMutation();

  const [amount, setAmount] = useState([1000]);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (type) => {
    if (type === 'invoice') {
      if (!amount[0]) {
        toast.error(t('tokens.selectTokenAmount'));
        return;
      }
      setLoading(true);
      try {
        const result = await createTransaction({ type, amount: amount[0] }).unwrap();
        if (result?.transaction) {
          navigate('/settings');
          dispatch(setActiveTab('billing'))
          toast.success(t('tokens.requestSent'));
        }
      } catch {
        toast.error('Failed to create transaction. Please try again.');
      }
    }
    setIsOpen(false);
    setLoading(false);
  }

  return (
    <Card className='border-none shadow-none py-0'>
      <CardContent className="p-0 flex flex-col gap-4">
        <div className="flex flex-col space-y-1.5">
          <Label htmlFor="amount" className="font-semibold">{t('tokens.topUpAmount')} <span className='text-sm'>{t('tokens.currency')}</span></Label>
          <Input
            id="amount"
            className="font-semibold"
            tabIndex="-1"
            placeholder="0"
            type="number"
            inputMode="numeric"
            pattern="[0-9]*"
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, '');
              setAmount([Number(value) || 0]);
            }}
            value={[amount]}
          />
        </div>
        <div>
          <Slider
            defaultValue={[0]}
            max={50000}
            step={100}
            value={[amount]}
            onValueChange={setAmount}
          />
        </div>
      </CardContent>
      <CardFooter className="p-0 mt-4">
        <Button
          disabled={loading}
          className="w-full"
          onClick={loading ? undefined : () => handleSubmit('invoice')}
        >
          {loading ?
            <Loader />
            :
            <span>{t('tokens.sendRequest')}</span>
          }
        </Button>
      </CardFooter>
    </Card>
  )
}

export default TokenTab
